export interface IClassNames {
  classNames?: string | string[];
}

const useClassNames = (...args: (string | string[] | false | undefined)[]) => ({
  className: args
    .flat()
    .filter((c) => !!c)
    .join(' ')
    .trim(),
});

export default useClassNames;
